import moment from 'moment';
import { getAffectationProduitUnitaireAsync, getAffectationProduitReseauLc } from '@/api/affectation/index';
import { CATEGORIE_UNITAIRE, CATEGORIE_REGROUPEMENT_LC } from '@/configuration/produitConf';
import formatIsoDate from '@/services/general/formatIsoDate';
import { TYPE_FACTURE, TYPE_COMMANDE } from '@/configuration/devisConf';

export async function getAffectionOfProductFace(lignesDeCommande) {
  const listAffectationAllProduit = [];
  lignesDeCommande.forEach((ligne) => {
    if (ligne.typeProduit === CATEGORIE_UNITAIRE && ligne.produit.controleDisponibilite) {
      listAffectationAllProduit.push({
        id: ligne.produitId,
        dureeAffectation: {
          dateDebut: formatIsoDate(ligne.dateDebut),
          dateFin: formatIsoDate(ligne.dateFin),
        },
      });
    }
  });
  const affectationOfProduit = (await getAffectationProduitUnitaireAsync(
    listAffectationAllProduit, false, true,
  )).data.result;
  return affectationOfProduit;
}

export function updateAffection(ligne, devisCommande, affectationOfLigne) {
  let idCommande;
  switch (devisCommande.type) {
    case TYPE_FACTURE:
      idCommande = devisCommande.reference ? devisCommande.reference.id : null;
      break;
    case TYPE_COMMANDE:
      idCommande = devisCommande.id;
      break;
    default:
      idCommande = null;
  }
  if (!affectationOfLigne) return;
  ligne.affectation = affectationOfLigne.filter((affectation) => {
    return affectation.referenceId !== idCommande
      && (moment(formatIsoDate(ligne.dateDebut))
        .isBetween(moment(affectation.dureeAffectation.dateDebut), moment(affectation.dureeAffectation.dateFin), 'day', '[]')
        || moment(formatIsoDate(ligne.dateFin))
          .isBetween(moment(affectation.dureeAffectation.dateDebut), moment(affectation.dureeAffectation.dateFin), 'day', '[]')
        || ((moment(affectation.dureeAffectation.dateDebut)
          .isBetween(moment(formatIsoDate(ligne.dateDebut)), moment(formatIsoDate(ligne.dateFin)), 'day', '[]')
        && (moment(affectation.dureeAffectation.dateFin)
          .isBetween(moment(formatIsoDate(ligne.dateDebut)), moment(formatIsoDate(ligne.dateFin)), 'day', '[]')))));
  });
}

export async function getAffectionOfProductReseauLc(lignesDeCommande) {
  const listAffectationAllProduit = [];
  lignesDeCommande.forEach((ligne) => {
    if (ligne.typeProduit === CATEGORIE_REGROUPEMENT_LC) {
      listAffectationAllProduit.push({
        id: ligne.produitId,
        dureeAffectation: {
          dateDebut: formatIsoDate(ligne.dateDebut),
          dateFin: formatIsoDate(ligne.dateFin),
        },
      });
    }
  });
  const affectationOfProduit = (await getAffectationProduitReseauLc(
    listAffectationAllProduit,
  )).data.result;
  return affectationOfProduit;
}

export async function updateAffectionOfAllProduct(devisCommande) {
  const affectationListProduitFace = await getAffectionOfProductFace(devisCommande.lignesCommande);
  const affectationListProduitReseauLc = await getAffectionOfProductReseauLc(
    devisCommande.lignesCommande,
  );
  devisCommande.lignesCommande.forEach((ligne) => {
    ligne.affectation = [];
    if (ligne.typeProduit === CATEGORIE_UNITAIRE) {
      updateAffection(ligne, devisCommande, affectationListProduitFace[ligne.produitId]);
    } else if (ligne.typeProduit === CATEGORIE_REGROUPEMENT_LC) {
      updateAffection(ligne, devisCommande, affectationListProduitReseauLc[ligne.produitId]);
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/affectation/affectation.js